import PropTypes from "prop-types";
import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import i18n from "../../i18n";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Permissions } from "../../constants/enums";

const CardCostCenter = ({ costCenter, setCheckCostCenter, checkCostCenter, showCheckboxes }) => {
  
  const name = costCenter.name;
  const nameIcon = name.charAt(0);
  const [colors, setColor] = useState(["primary", "warning", "danger", "success", "info", "dark"]);
  const [infoUser, setInfoUser] = useState({ permissions: [] });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [drp_link, setDrp_link] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random()
      * (max - min + 1)) + min;
  };

  const getColor = () => {
    return colors[randomNumberInRange(1, 6)];
  };

  const checkRemove = (val, costCenter) => {
    let arr = [...checkCostCenter];
    if (val.target.checked) {
      if (!arr.includes(costCenter)) {
        arr.push(costCenter);
      }
    } else {
      arr.splice(arr.indexOf(costCenter), 1);
    }
    setCheckCostCenter(arr);
  };

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    if (data?.data) {
      setInfoUser(data.data);
    }
  }, [data, loading]);

  const handleSelectCostCenter = (costCenter) => {
    const partnerId = costCenter.partner_id;
    localStorage.setItem('selectedPartnerId', partnerId);
    localStorage.setItem('selectedCostCenterId', costCenter.id);
    localStorage.setItem('selectedCostCenterName', costCenter.name);
  };

  return (
    <Fragment>
      <Col xl="4" sm="6">
        <Card className="position-relative">
          <div className="dropdown-container">
            <ButtonDropdown isOpen={drp_link} toggle={() => setDrp_link(!drp_link)}>
              <DropdownToggle className="btn btn-cost-center p-0 text-secondary" caret={false}>
                ...
              </DropdownToggle>
              <DropdownMenu className="custom-dropdown-menu">
                <DropdownItem onClick={() => handleSelectCostCenter(costCenter)}>
                  <Link to={`/cost-centers/sub-admin/${costCenter.id}`} className="dropdown-link">
                    {i18n.t("AssignSubAdmins")}
                  </Link>
                </DropdownItem>
                <DropdownItem onClick={() => handleSelectCostCenter(costCenter)}>
                  <Link to={`/cost-centers/sub-admins/${costCenter.id}`} className="dropdown-link">
                    {i18n.t("ViewSubAdmins")}
                  </Link>
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
          </div>
          <Row>
            <Col xl="5">
              <div className="text-center p-4 border-end">
                {showCheckboxes && (
                  <input
                    name="remove[][id]"
                    type="checkbox"
                    onClick={(val) => checkRemove(val, costCenter)}
                    id={costCenter.id}
                    className="d-block"
                  />
                )}
                <div className="avatar-sm mx-auto mb-3 mt-1">
                  <span
                    className={
                      "avatar-title rounded-circle bg-" +
                      getColor() +
                      "-subtle primary text-" +
                      getColor() +
                      " font-size-16"
                    }
                  >
                    {nameIcon}
                  </span>
                </div>
                <h5 className="text-truncate pb-1">{costCenter.name}</h5>
                <p className="">({costCenter.partner_name})</p>
              </div>
            </Col>
            <Col xl="7">
              <div className="p-4 text-center text-xl-start">
                <Row>
                  <Col xs="6">
                    <div>
                      <p className="text-muted mb-2 text-truncate">{i18n.t("Members")}</p>
                      <h5>{costCenter.total_employees}</h5>
                    </div>
                  </Col>
                  <Col xs="6">
                    <div>
                      <p className="text-muted mb-2 text-truncate">
                        {i18n.t("Services")}
                      </p>
                      <h5>{costCenter.services}</h5>
                    </div>
                  </Col>
                </Row>
                <div className="mt-4">
                  {infoUser.permissions.includes(Permissions.WRITE_EMPLOYEE) && (
                    <Link
                      to={"/cost-centers/" + costCenter.id}
                      onClick={() =>
                        localStorage.setItem("SelectCostCenter", JSON.stringify(costCenter))
                      }
                      className="text-decoration-underline text-reset"
                    >
                      {i18n.t("ShowDetail")}
                      <i className="mdi mdi-arrow-right"></i>
                    </Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Fragment>
  );
};

CardCostCenter.propTypes = {
  costCenter: PropTypes.object,
  showCheckboxes: PropTypes.bool,
};

export default CardCostCenter;
